import React from 'react';
import { List } from 'antd';
import { Inference as InferenceType } from '../../../types';

import { Inference } from './Inference';

type Props = {
  inferenceList: InferenceType[];
  onItemClickUrl: (trainingId: string) => any;
};
export const InferenceList = ({ inferenceList, onItemClickUrl }: Props) => {
  return (
    <div>
      {inferenceList && inferenceList.length > 0 && (
        <List
          style={{ marginLeft: '20px' }}
          itemLayout="horizontal"
          dataSource={inferenceList}
          renderItem={inference => <Inference inference={inference} onItemClickUrl={onItemClickUrl} />}
        />
      )}
    </div>
  );
};
